export const RACING_LOADING = 'RACING_LOADING';
export const RACING_INIT = 'RACING_INIT';
export const RACING_LOADING_SUCCESS = 'RACING_LOADING_SUCCESS';
export const RACING_LOADED_EMPTY = 'RACING_LOADED_EMPTY';
export const RACING_LOADING_ERROR = 'RACING_LOADING_ERROR';
export const RACING_UPDATE_SCHEDULE = 'RACING_UPDATE_SCHEDULE';
export const RACING_UPDATE_SCHEDULE_FROM_CACHE = 'RACING_UPDATE_SCHEDULE_FROM_CACHE';
export const RACING_INVALIDATE_SCHEDULE_CACHE = 'RACING_INVALIDATE_SCHEDULE_CACHE';
export const RACING_WS_EVENT_UPDATE = 'RACING_WS_EVENT_UPDATE';
export const RACING_RACECARD_UPDATE = 'RACING_RACECARD_UPDATE';
export const RACING_RACECARD_UPDATE_FROM_CACHE = 'RACING_RACECARD_UPDATE_FROM_CACHE';
export const RACING_RACECARD_UPDATE_SELECTION_PRICE = 'RACING_RACECARD_UPDATE_SELECTION_PRICE';
export const RACING_WS_EVENT_UNSUBSCRIBE = 'RACING_WS_EVENT_UNSUBSCRIBE';
export const RACING_SET_IS_STREAMING = 'RACING_SET_IS_STREAMING';
